import axios from 'axios';
import keycloak from '../../keycloak';

function resolveAuthToken() {
  if (import.meta.env.VITE_KEYCLOAK === 'true' && keycloak.authenticated && keycloak.token) {
    return `Bearer ${keycloak.token}`;
  }

  const token = localStorage.getItem('jwt') || localStorage.getItem('token');
  if (!token) return null;

  return token.startsWith('Bearer ') ? token : `Bearer ${token}`;
}

export const projectManagementApi = axios.create({
  baseURL: '/project-management-api',
  headers: {
    'Content-Type': 'application/json',
  },
});

projectManagementApi.interceptors.request.use(
  (config) => {
    const tokenValue = resolveAuthToken();
    if (tokenValue) {
      // eslint-disable-next-line no-param-reassign
      config.headers.Authorization = tokenValue;
    }
    return config;
  },
  (error) => Promise.reject(error),
);

projectManagementApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const currentPath = window.location.pathname;
      if (currentPath !== '/auth' && currentPath !== '/login') {
        window.location.href = '/auth';
      }
    }
    return Promise.reject(error);
  },
);
